import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { StorytellerReduxStore } from '../../store/StorytellerReduxStore';
import { StoryCopyModal } from '../components/StoryCopyModal';

interface StoryCopierRendererOptions {
  storyCopierContainerElement?: JQuery<HTMLElement>;
}

export function StoryCopierRenderer(options: StoryCopierRendererOptions): void {
  const container = options.storyCopierContainerElement?.[0] || null;
  if (container) {
    ReactDOM.render(
      <Provider store={StorytellerReduxStore}>
        <StoryCopyModal />
      </Provider>,
      container,
    );
  }
}
